const BUYER_ROLES = new Set(['buyer', 'enterprise', 'model-developer', 'researcher', 'legal', 'procurement', 'finance']);

export const isAdmin = (user) => user?.role === 'admin';
export const isDataProvider = (user) => user?.role === 'data-provider';
export const isBuyer = (user) => BUYER_ROLES.has(user?.role);
export const isBuyerOperator = (user) =>
  isBuyer(user) && ['workspace-admin', 'buyer'].includes(user?.workspace?.workspaceRole || 'buyer');
export const canUseVendorTools = (user) => isDataProvider(user) || isAdmin(user);
export const canUseDatasetWorkspace = (user) => isBuyer(user) || isDataProvider(user);
export const canUseAnnotator = (user) => isDataProvider(user) || isAdmin(user);
// Buyers (and admins) can browse talent and invite them to their data tasks.
export const canInviteTalent = (user) => isBuyer(user) || isAdmin(user);

// Granular, super-admin-controlled feature modules. Toggling one hides/shows its nav item + route.
export const MODULES = [
  { key: 'marketplace', label: 'Data Marketplace', group: 'Discovery', description: 'Browse, compare and license datasets (incl. dataset detail & compare).' },
  { key: 'search', label: 'Smart Search', group: 'Discovery', description: 'Natural-language search across the catalogue.' },
  { key: 'benchmarks', label: 'Benchmarks', group: 'Discovery', description: 'Benchmark suites, results and use-cases.' },
  { key: 'buyer-intel', label: 'Buyer Intel', group: 'Vendor tools', description: 'Aggregated demand signals for data owners.' },
  { key: 'demand', label: 'Live Demand', group: 'Vendor tools', description: 'Urgency-tiered demand board — what buyers are funding right now.' },
  { key: 'call-for-data', label: 'Call for Data', group: 'Sourcing', description: 'Open sourcing requests buyers and vendors respond to.' },
  { key: 'request-data', label: 'Request Data', group: 'Sourcing', description: 'Private dataset requests / procurement.' },
  { key: 'talent', label: 'Talent Network', group: 'Sourcing', description: 'Browse annotator/vendor profiles and invite them to data tasks.' },
  { key: 'my-datasets', label: 'My Datasets', group: 'Workspace', description: 'Licensed and campaign-collected data.' },
  { key: 'workbench', label: 'Workbench', group: 'Annotation', description: 'The annotation studio.' },
  { key: 'tasks', label: 'Data Tasks', group: 'Annotation', description: 'Collection & annotation micro-tasks.' },
];

export const MODULE_KEYS = MODULES.map((m) => m.key);

// A module is visible unless a super-admin explicitly disabled it for this user.
// Super-admins always retain full access (so they can never lock themselves out of the console).
export const canAccessModule = (user, moduleKey) => {
  if (isAdmin(user)) return true;
  return user?.moduleAccess?.[moduleKey] !== false;
};
